import React, { useContext } from 'react';
import Display from '../Display';
import Disclaimer from '../Disclaimer';
import { ProductContext } from '../ProductContext';

const Home = () => {
  const { selectedProductId } = useContext(ProductContext);

  return (
    <div key={selectedProductId}>
      <Display />
      <Disclaimer />
    </div>
  );
};

export default Home;
